import { Suspense } from "react";
import dayjs from "dayjs";
import { useTranslations } from "use-intl";
import { useSettingsSupplier } from "@/app/Suppliers/Utils/useSettingsSupplier";
import { SettingCard } from "@/app/Settings/Settings/Components/SettingFormCard";
import { NoSupplierEmptyState } from "@/app/Settings/Settings/Components/NoSupplierEmptyState";
import { SupplierActiveLinesPieChart } from "@/app/Suppliers/Components/SupplierActiveLinesPieChart";
import { SupplierFerryDatesCard } from "@/app/Suppliers/Components/SupplierFerryDatesCard";
import { RelocationLineTable } from "@/app/Relocations/Components/RelocationLineReferenceTable";
import {
  QueryRelocationLinesWhereGroupColumn,
  SqlOperator,
} from "@/gql/graphql";

export function SettingsActiveLinesScreen() {
  const { supplier } = useSettingsSupplier();
  const t = useTranslations("settings.activeLines");

  if (!supplier) {
    return <NoSupplierEmptyState />;
  }

  return (
    <div className="space-y-8">
      <Suspense fallback={null}>
        <SupplierActiveLinesPieChart supplierId={supplier.id} />
      </Suspense>

      <SettingCard title={t("title")} description={t("description")}>
        <RelocationLineTable
          id="settings-line-references"
          queryVariables={{
            whereGroup: {
              AND: [
                {
                  column: QueryRelocationLinesWhereGroupColumn.ExpiresAt,
                  operator: SqlOperator.Gte,
                  value: dayjs().toISOString(),
                },
                {
                  column: QueryRelocationLinesWhereGroupColumn.SupplierId,
                  value: supplier.id,
                },
              ],
            },
          }}
        />
      </SettingCard>

      <Suspense fallback={null}>
        <SupplierFerryDatesCard supplierId={supplier.id} />
      </Suspense>
    </div>
  );
}
